<ng-container [ngSwitch]="status">
  <mat-chip-list>
    <mat-chip *ngSwitchCase="SHARE_STATUS.Accepted" size="sm" outlined class="accepted-share-chip">
      <div class="accepted-share-chip-label">
        <span>{{ 'common.accepted' | t }}</span>
      </div>
    </mat-chip>
    <mat-chip
      *ngSwitchCase="SHARE_STATUS.Unaccepted"
      size="sm"
      outlined
      class="not-accepted-share-chip"
    >
      <div class="not-accepted-share-chip-label">
        <span>{{ 'common.notAccepted' | t }}</span>
      </div>
    </mat-chip>
    <mat-chip *ngSwitchCase="SHARE_STATUS.Pending" size="sm" outlined class="pending-share-chip">
      <div class="pending-share-chip-label">
        <span>{{ 'common.pending' | t }}</span>
      </div>
    </mat-chip>
  </mat-chip-list>
</ng-container>
